// extracted by mini-css-extract-plugin
module.exports = {"efCollectionPCA":"A_efCollectionPCA__q710L"};